import { StyledCustomButtons, StyledLoginForm } from './style';
import { Input } from '../../Input';
import { Button } from '../../Button';
import { useIntl } from 'react-intl';
import { Checkbox } from 'ui/Checkbox';
import { Flex, FormInstance } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { AuthType } from './LoginForm';
import { Divider } from '../../Divider';
import { Label } from '../../Label';
import { Icon } from 'ui';
import { useNavigate } from 'react-router-dom';
import PublicRoute from 'enums/publicRoutes';

export interface RegisterProps {
  appendData: any;
  form: FormInstance<any>;
  isLoading: boolean;
}

const STORAGE_KEY = 'register-form-draft';

export const RegisterForm = ({
  appendData,
  form,
  isLoading,
}: RegisterProps) => {
  const [selectedAuthType, setSelectedAuthType] = useState(AuthType.Physical);

  const intl = useIntl();
  const navigate = useNavigate();
  const APP_URL = window.runConfig.backendUrl;

  useEffect(() => {
    const draft = localStorage.getItem(STORAGE_KEY);
    if (draft) {
      try {
        form.setFieldsValue(JSON.parse(draft));
      } catch {}
    }
  }, [form]);

  const handleSubmit = (values: any) => {
    localStorage.removeItem(STORAGE_KEY);

    appendData(values);
  };

  const handleValuesChange = useCallback(() => {
    const allValues = form.getFieldsValue();

    const { password, password_confirmation, ...safeValues } = allValues;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(safeValues));
  }, [form]);

  return (
    <StyledLoginForm
      onFinish={handleSubmit}
      form={form}
      onValuesChange={handleValuesChange}
    >
      <div className={'inputs'}>
        <div className={'register-mobile-header'}>
          <div className={'register-title'}>
            {intl.formatMessage({ id: 'register.title' })}
          </div>
          <div className={'register-description'}>
            {intl.formatMessage({ id: 'register.description' })}
          </div>
        </div>
        <StyledCustomButtons>
          <div
            className={`custom-button ${selectedAuthType === AuthType.Physical ? 'active' : ''}`}
            onClick={() => setSelectedAuthType(AuthType.Physical)}
          >
            {intl.formatMessage({ id: 'login.private_person' })}
          </div>
          <div
            className={`custom-button ${selectedAuthType === AuthType.Legal ? 'active' : ''}`}
            onClick={() => setSelectedAuthType(AuthType.Legal)}
          >
            {intl.formatMessage({ id: 'login.legal_person' })}
          </div>
        </StyledCustomButtons>
        {selectedAuthType === AuthType.Physical ? (
          <>
            <div className={'registration-input-wrapper'}>
              <div className={'fulname'}>
                <div>
                  <span className="label">
                    {intl.formatMessage({ id: 'register.name' })}
                  </span>

                  <Input size={'large'} required name={'name'} />
                </div>
                <div>
                  <span className="label">
                    {intl.formatMessage({ id: 'register.surname' })}
                  </span>
                  <Input size={'large'} required name={'surname'} />
                </div>
              </div>

              <div className={'email'}>
                <span className="label">
                  {intl.formatMessage({ id: 'register.e_mail' })}
                </span>
                <Input
                  size={'large'}
                  required
                  name={'email'}
                  validations={['required', 'email']}
                />
              </div>

              <div className={'email_again'}>
                <span className="label">
                  {intl.formatMessage({ id: 'register.e_mail_again' })}
                </span>
                <Input
                  size={'large'}
                  required
                  name={'reemail'}
                  dependencies={['email']}
                  validations={['required', 'email', 'reemail']}
                />
              </div>

              <div className={'pw-wrap'}>
                <div className={'pw-first'}>
                  <span className="label">
                    {intl.formatMessage({ id: 'register.password' })}
                  </span>
                  <Input
                    password
                    size={'large'}
                    required
                    name={'password'}
                    validations={['required', 'password']}
                  />
                </div>
                <div className={'pw-scnd'}>
                  <span className="label">
                    {intl.formatMessage({ id: 'register.password_again' })}
                  </span>
                  <Input
                    password
                    size={'large'}
                    required
                    name={'password_confirmation'}
                    dependencies={['password']}
                    validations={['required', 'password_confirmation']}
                  />
                </div>
              </div>
              <div className={'accept_terms'}>
                <Checkbox
                  name={'subscribe_to_news'}
                  label={intl.formatMessage({ id: 'register.accept_terms' })}
                />
              </div>
            </div>

            <div className={'no-acc-reg register-login-redirect'}>
              {intl.formatMessage({ id: 'register.have_acc' })}
              <a href={PublicRoute.LOGIN} className="login_link">
                {intl.formatMessage({ id: 'register.login' })}
              </a>
            </div>

            <div className={'registration-button-wrapper'}>
              <div className={'registration-buttons'}>
                <Button
                  className={'cstm-btn'}
                  label={intl.formatMessage({ id: 'register.create_account' })}
                  size={'large'}
                  htmlType={'submit'}
                  loading={isLoading}
                />
                <Divider />
                <Flex gap={10}>
                  <Button
                    label={intl.formatMessage({ id: 'login.use_google' })}
                    className={'cstm-btn google'}
                    icon={<img src={'/google.png'} alt="Google" />}
                    onClick={() =>
                      (window.location.href = `${APP_URL}/api/v2/login/google`)
                    }
                  />
                  {/* <Button
                    label={intl.formatMessage({ id: 'login.use_facebook' })}
                    className={'cstm-btn google'}
                    icon={<img src={'/facebook.png'} alt="Facebook" />}
                    onClick={() =>
                      (window.location.href = `${APP_URL}/api/v2/login/facebook`)
                    }
                  /> */}
                </Flex>
              </div>
            </div>
          </>
        ) : (
          <div>
            <div className={'registration-button-wrapper border-wrapper'}>
              <Label
                extraBold
                label={intl.formatMessage({ id: 'register.label' })}
              />
              <Label
                bold
                label={intl.formatMessage({ id: 'register.label_text2' })}
              />
              <div className={'registration-buttons'}>
                <Button
                  label={' '}
                  className={'cstm-btn google'}
                  icon={<img src={'/latvijalv.svg'} alt="Latvija.lv" />}
                  onClick={() =>
                    window.location.replace(APP_URL + '/vpm/login?legal=1')
                  }
                />
              </div>
            </div>

            <div className={'registration-button-wrapper border-wrapper'}>
              <Label
                extraBold
                label={intl.formatMessage({ id: 'register.label' })}
              />
              <Label
                bold
                label={intl.formatMessage({ id: 'register.label_text' })}
              />

              <div className={'registration-buttons'}>
                <Button
                  label={' '}
                  className={'cstm-btn google'}
                  icon={<img src={'/latvijalv.svg'} alt="Latvija.lv" />}
                  onClick={() =>
                    window.location.replace(APP_URL + '/vpm/login?register=1')
                  }
                />
              </div>
            </div>
          </div>
        )}
        <div className={'home-button-wrapper'}>
          <Button
            label={intl.formatMessage({ id: 'navigation.to_start' })}
            className={'cstm-btn home'}
            onClick={() => navigate(PublicRoute.HOME)}
            icon={<Icon name={'got-to-home-page-auth-arrow'} />}
            type={'link'}
          />
        </div>
      </div>
    </StyledLoginForm>
  );
};
